export class AttributeTransformer {
  
      static transform(obj) {
        let code = {};
        code.id = obj.id;
        code.code = obj.attributes.code;
        code.name = obj.attributes.name;
        code.value = obj.attributes.value ? obj.attributes.value : null;
        code.createdBy = obj.attributes.created_by;
        code.attribute_id = obj.attributes.attribute_id ?  obj.attributes.attribute_id : null;
        code.archived_at = obj.attributes.archived_at;
        return code;
      }
  
      static transformArray(array = []) {
          let data = [];
          array.map(function (item) {
              data.push(AttributeTransformer.transform(item));
          });
          return data;
      }
  }


// WEBPACK FOOTER //
// ./src/helpers/attributes/attribute.transformer.js